<template>
  <div
    id="loading"
    :class="{'show':inProgress}"
  />
</template>

<script>
  const RESP_OK = 0;
  const RESP_VALIDATION_ERROR = 1;
  const RESP_MSISDN_NOT_PREPAID = 2;
  const RESP_PASSWORD_INCORRECT = 3;
  const RESP_TEMPORARILY_LOCKED = 4;
  const RESP_LOCKED = 5;
  const RESP_NOT_REGISTERED = 6;
  const RESP_ACTIVATION_IN_PROGRESS = 7;
  const RESP_INCORRECT_SUBSCRIBER_TYPE = 8;
  const RESP_SSO_TOKEN_NOT_VALID = 9;
  const RESP_OTHER_ERROR = 9999;

  export default {
    name: "SsoLogin",
    components: {},
    data: function() {
      return {
        inProgress: true,
      };
    },
    mounted: function() {
      const loginRequest = {
        token: this.parseToken(),
      };

      this.$http.post('api/dreitvkarte/accessTokenFromSSOToken', loginRequest)
        .then( response => {
          this.processSuccessfulCallResponse(response);
        })
        .catch(callData => {
          this.processErrorCallResponse(callData);
          this.$router.push({name: 'login'});
          this.inProgress = false;
        })
    },
    methods: {
      parseToken: function() {
        const hash = window.location.hash;
        const queryString= hash.substr(hash.indexOf('?'));
        const urlParams = new URLSearchParams(queryString);
        if(urlParams.get('token')) {
          return urlParams.get('token')
        }
        return urlParams.get('t');
      },
      processSuccessfulCallResponse: function(response) {
        let loginResponse = response.data;
        this.$store.commit('setUserDetail', loginResponse.userDetail);
        this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Login SSO',label: 'Success', value: 0, noninteraction: false });
        this.$router.push({name: 'manage'});
      },
      processErrorCallResponse: function(callData) {
          if(callData.response === undefined || callData.response.data === undefined) {
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Login SSO',label: 'Error - no data', value: 0, noninteraction: false });
          return;
        }

        let responseCode = callData.response.data.responseCode;

        switch(responseCode) {
          case RESP_VALIDATION_ERROR:
            this.$store.commit("setErrorMessage", this.$i18n.t('LOGIN.ERROR_MESSAGES.CREDENTIALS_INCORRECT'));
            this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Login SSO',label: 'Error - validation error', value: 0, noninteraction: false });
            break;
          case RESP_PASSWORD_INCORRECT:
            this.$store.commit("setErrorMessage", this.$i18n.t('LOGIN.ERROR_MESSAGES.CREDENTIALS_INCORRECT'));
            this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Login SSO',label: 'Error - password incorrect', value: 0, noninteraction: false });
            break;
          case RESP_TEMPORARILY_LOCKED:
            this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.LOGIN_TEMPORARILY_LOCKED'));
            this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Login SSO',label: 'Error - temporarily locked', value: 0, noninteraction: false });
            break;
          case RESP_LOCKED:
            this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.LOGIN_LOCKED'));
            this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Login SSO',label: 'Error - locked', value: 0, noninteraction: false });
            break;
          case RESP_NOT_REGISTERED:
            this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.SUBSCRIPTION_NOT_YET_REGISTERED'));
            this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Login SSO',label: 'Error - not registered', value: 0, noninteraction: false });
            break;
          case RESP_MSISDN_NOT_PREPAID:
            this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.MSISDN_NOT_ACTIVE_PREPAID'));
            this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Login SSO',label: 'Error - MSISDN not prepaid', value: 0, noninteraction: false });
            break;
          case RESP_INCORRECT_SUBSCRIBER_TYPE:
            this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.MSISDN_NOT_ACTIVE_PREPAID'));
            this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Login SSO',label: 'Error - wrong subscriber type', value: 0, noninteraction: false });
            break;
          case RESP_SSO_TOKEN_NOT_VALID:
            this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
            this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Login SSO',label: 'Error - SSO token not valid', value: 0, noninteraction: false });
            break;
          case RESP_OTHER_ERROR:
            this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
            this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Login SSO',label: 'Error - technical issue', value: 0, noninteraction: false });
            break;
          default:
            this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
            this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Login SSO',label: 'Error - '+ responseCode, value: 0, noninteraction: false });
        }
      }
    },
  }
</script>

<style lang="scss" src="@/components/loading/loading.scss">
</style>
